import Controls from './Controls';

export default Controls;



// WEBPACK FOOTER //
// ./src/components/Controls/index.js